export default __webpack_public_path__ + "static/media/20.c40a92cf.jpg";